import moment from 'moment';
import getArrayTrueElementsCount from './getArrayTrueElementsCount';
import getFormData from './getFormData';
import { PHOTOS_COUNT } from './constants';
import isValidDate from './isValidDate';
import checkCoordinates from './checkCoordinates';

function checkAddEventPayload({
  owner_id,
  name,
  country_id,
  city_id,
  specialization,
  address,
  coordinates,
  holding_date,
  date_start,
  date_end,
  contacts,
  description,
  photos,
  withPhotos = true,
  events_category_id,
  isOtherCategory = false,
  is_in_all_cities_of_country = false,
}) {
  const errors = [];
  const isInAllCities = Boolean(is_in_all_cities_of_country);

  if (owner_id?.length !== 24) {
    errors.push(' * неправильный формат ID пользователя (24 символа)');
  }
  if (name.length < 2) {
    errors.push(' * название не меньше 2 символов');
  } else if (name.length > 100) {
    errors.push(' * название не больше 100 символов');
  }
  if (!events_category_id) {
    errors.push(' * не выбрана категория события');
  }
  // Если выбрана категория "Другое", специализация обязательна
  if (isOtherCategory) {
    if (!specialization || specialization.trim().length < 2) {
      errors.push(' * специализация обязательна и не меньше 2 символов');
    }
  } else if (specialization && specialization.length > 0 && specialization.length < 2) {
    // Для других категорий специализация необязательна, но если заполнена, должна быть валидной
    errors.push(' * специализация не меньше 2 символов');
  }
  if (holding_date?.length < 2) {
    errors.push(' * дата проведения не меньше 2 символов');
  }
  if (isInAllCities) {
    if (!country_id) {
      errors.push(' * не выбрана страна');
    }
  } else if (city_id) {
    if (address.length < 2) {
      errors.push(' * адрес не меньше 2 символов');
    }
    if (!checkCoordinates(coordinates?.lat, coordinates?.lon)) {
      errors.push(' * не валидные координаты');
    }
  } else {
    errors.push(' * не выбран город');
  }
  if (getArrayTrueElementsCount(Object.values(contacts)) < 1) {
    errors.push(' * укажите хотя бы один из методов контакта с вами');
  }
  if (description.length < 2) {
    errors.push(' * описание не меньше 2 символов');
  }
  if (withPhotos && photos.length < PHOTOS_COUNT.carouselMin) {
    errors.push(` * выберите хотя бы ${PHOTOS_COUNT.carouselMin} фото`);
  } else if (withPhotos && photos.length > 15) {
    errors.push(' * выберите не больше 15 фото');
  }

  if (errors.length) {
    return { errors };
  }

  // Если выбрана категория "Другое", используем введенную специализацию
  // (она уже проверена выше на обязательность)
  let finalSpecialization = specialization;

  const payload = {
    owner_id,
    name,
    country_id,
    holding_date,
    contacts,
    description,
    events_category_id,
    is_in_all_cities_of_country: isInAllCities,
  };

  if (!isInAllCities) {
    payload.city_id = city_id;
    payload.address = address;
  }

  // Добавляем specialization только если оно заполнено
  if (finalSpecialization && finalSpecialization.trim().length > 0) {
    payload.specialization = finalSpecialization;
  }

  if (isValidDate(new Date(date_start))) payload.date_start = moment.utc(date_start, 'YYYY-MM-DD').startOf('day').toISOString();
  if (isValidDate(new Date(date_end))) payload.date_end = moment.utc(date_end, 'YYYY-MM-DD').startOf('day').toISOString();

  if (!isInAllCities && city_id) {
    payload.lat = coordinates?.lat ? coordinates.lat.toString() : '0';
    payload.lon = coordinates?.lon ? coordinates.lon.toString() : '0';
    payload.is_special_point_on_map = Boolean(coordinates?.is_special_point_on_map);
  }
  if (withPhotos) {
    const formData = getFormData(payload, photos);
    return { formData };
  }
  return { payload };
}

export default checkAddEventPayload;
